module.exports = __webpack_public_path__ + "img/icon-profile.07b566d6.svg";